import React from 'react'
import { pages } from './navigation'
import {NavLink } from 'react-router-dom'

const index = () => {
  return (
    <>
    <div className='h-full z-30 sticky  flex flex-row bottom-0 justify-around w-full md:flex md:flex-col md:top-0 md:fixed md:justify-around md:w-2/12  md:h-4/6'>
        {
          pages.map((item)=>!item.hidden && (
            <NavLink key={item.name} className={`flex p-5 gap-5 `}  to={`/${item.path}`}>
            <div>{item.icon}</div>
            <div className='font-body hidden	sm:block'>{item.name}</div>
            </NavLink>
          ))
        }
        </div>
    </>
  )
}

export default index